import React from 'react';

import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { StatCard, ActionButton } from '@europrocurement/l2d-modules';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import {
    AchatsAppDispatch,
    CategorieStats,
    CategorieStatsSelector,
    CodeRejetStats,
    CodeRejetStatsSelector,
    useAchatsService,
} from '@europrocurement/l2d-domain';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type CodeRejetsPanelProps = {
    afficherZeros: boolean;
    cardsProps: { [key: string]: IconProp };
};

const CodeRejetsPanel: React.FunctionComponent<CodeRejetsPanelProps> = function ({
    afficherZeros,
    cardsProps,
}) {
    const { getCategorieStats } = useAchatsService();

    const categoriesDataSource: DataSource<CategorieStats> =
        useSelector(CategorieStatsSelector).main;
    const codesRejetsDataSource: DataSource<CodeRejetStats> =
        useSelector(CodeRejetStatsSelector).main;
    const codesRejets = codesRejetsDataSource.data;

    const dispatch = useDispatch<AchatsAppDispatch>();
    const navigate = useNavigate();

    const parseCategorieName = (codeRejetName: string) => {
        if (['VEAA', 'VEADJ', 'VEMP'].includes(codeRejetName)) {
            return codeRejetName.substring(0, 2);
        }

        return codeRejetName.substring(0, 4);
    };

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                xs={12}
            >
                <Grid
                    container
                    spacing={2}
                >
                    {[...codesRejets]
                        .sort((a, b) => {
                            if (!a.name || !b.name) return 0;
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        })
                        .map((codeRejet) =>
                            codeRejet &&
                            codeRejet.name &&
                            (!afficherZeros ? codeRejet.count && codeRejet.count !== 0 : true) ? (
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={4}
                                    key={`${codeRejet.name} • ${codeRejet.libelle}`}
                                >
                                    <StatCard
                                        title={`${codeRejet.name} • ${codeRejet.libelle}`}
                                        icon={cardsProps[parseCategorieName(codeRejet.name)]}
                                        color={parseCategorieName(codeRejet.name)}
                                        data={codeRejet.count}
                                        actions={
                                            [
                                                {
                                                    label: `Détails ${codeRejet.name}`,
                                                    onClick: () => {
                                                        dispatch({
                                                            type: `${categoriesDataSource.slicename}/set${categoriesDataSource.name}Filter`,
                                                            payload: {
                                                                key: 'codesRejets',
                                                                value: [codeRejet.name],
                                                            },
                                                        });
                                                        dispatch(getCategorieStats({}));
                                                        navigate('/achats/stats?tab=detail');
                                                    },
                                                },
                                            ] as ActionButton[]
                                        }
                                        sx={{
                                            minHeight: '90%',
                                        }}
                                    />
                                </Grid>
                            ) : (
                                false
                            ),
                        )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CodeRejetsPanel;
